import Link from 'next/link'
import DateComponent from './date'
import CoverImage from './cover-image'

export default function PostPreview({
    title, coverImage, slug,
    date, excerpt
}) {
    return (
        (<Link as={`/insights/${slug}`} href="/insights/[slug]">
            <div className={`block sm:grid sm:gap-6 md:gap-12 lg:gap-0 sm:grid-cols-2 md:col-span-1 lg:block insightItem mb-16 sm:mb-8 md:mb-6`}>

                <div className={`sm:mb-0 mb-6 md:mb-5 md:col-span-1 lg:col-span-full lg:h-full navImage rounded-md hover:scale-75 `}>
                    <CoverImage title={title} slug={slug} url={coverImage?.url} fullHeight extraClass />
                </div>

                <div className={"sm:col-span-1 md:col-span-1 lg:col-span-full md:p-0 flex flex-column justify-center"}>

                    {/* <div className="text-lg mb-4 border-b pb-4"> */}
                    <div className={"flex flex-row items-center justify-between border-b mb-4 pb-4 text-lg text-gray-500 pt-0 md:pt-0"}>
                        <div className="flex flex-row items-center">
                            <img src={"/images/calendar.svg"} style={{ width: 20, height: 20 }} />
                            <div className={"ml-3"}>
                                <DateComponent dateString={date} />
                            </div>
                        </div>
                    </div>

                    <h3 className="text-xl lg:text-2xl mb-6 leading-snug insightTitle">
                        <Link
                            as={`/insights/${slug}`}
                            href="/insights/[slug]"
                            className="hover:underline font-bold">
                            {String(excerpt).substring(0, 100) + "..."}
                        </Link>
                    </h3>

                </div>
            </div>
        </Link>)
    );
}